export default function CriteriaExpressionTemplate(data) {
    //language=HTML
    return `
        <div class="row w-100 mx-auto mb-1 align-items-center pt-1 criteriaExpressionPart" id="listScreenCriteria${data.groupNumber}">
            <div class="col-lg-3 col-md-6 mb-1">
                <div>
                    <input class="w-100 test" id="field${data.groupNumber}">
                </div>
            </div>

            <div class="col-lg-3 col-md-6 mb-1">
                <div id="expressionOperatorPart${data.groupNumber}">
                    <input class="w-100 test" id="operator${data.groupNumber}">
                </div>
            </div>

            <div class="col-lg-5 col-md-9 mb-1">
                <div class="nama-criteria-part bg-white">
                </div>
            </div>
            <div class="col-lg-1 col-md-3 col-4 mb-1 mx-auto">
                <div class=" d-flex justify-content-between justify-content-md-around">
                    <a role="button" class=" text-secondary" id="copyCriteria${data.groupNumber}"><i class="fa-solid fa-copy fa-1-5x"></i></a>
                    <a role="button" class=" text-secondary deleteExpression" id="deleteCriteria${data.groupNumber}"><i
                            class="fa-solid fa-trash-can fa-1-5x"></i></a>
                    <a role="button" class=" text-secondary addCriteria" id="addCriteria${data.groupNumber}"><i class="fa-solid fa-plus fa-1-5x"></i></a>
                </div>
            </div>
        </div>`;
}